import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GlobalConstants } from "../common/global-constants";
import { BOItem } from "../models/BOItem.model";

@Injectable()
export class DiseaseService{
    myAppUrl = GlobalConstants.apiURL;
    myApiUrl = 'api/Disease';

    constructor(private http:HttpClient){}

    getAll(diseaseFilter:string):Observable<BOItem[]>{
        return this.http.get<BOItem[]>(this.myAppUrl + this.myApiUrl +'/'+ diseaseFilter);
    }
}
